export { ScanQrPage } from './ScanQrPage'
